import { render, staticRenderFns } from "./PowTourPrvsMng.vue?vue&type=template&id=16601124&"
import script from "./PowTourPrvsMng.vue?vue&type=script&lang=js&"
export * from "./PowTourPrvsMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports